import { useTranslation } from 'react-i18next'

import styles from './MonthlySignoffRightPanel.module.scss'
import aidenShaw from './assets/aiden-shaw.png'
import carrieBradshaw from './assets/carrie-bradshaw.png'
import { ReactComponent as Checkmark } from './assets/checkmark.svg'
import mirandaHobbes from './assets/miranda-hobbes.png'

const EMPLOYEES = [
  { id: 'aiden', avatar: aidenShaw, status: 'confirmed' },
  { id: 'miranda', avatar: mirandaHobbes, status: 'confirmed' },
  { id: 'carrie', avatar: carrieBradshaw, status: 'pending' }
] as const

export const MonthlySignoffRightPanel = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_page_onboarding.main_screen.steps.monthly_signoff'
  })

  return (
    <section className={styles.panel} aria-label={t('panel_label')}>
      <header className={styles.header}>
        <h3 className={styles.title}>{t('title')}</h3>
        <p className={styles.period}>{t('period')}</p>
      </header>

      <div className={styles.employees}>
        {EMPLOYEES.map(employee => (
          <div
            key={employee.id}
            className={`${styles.employee} ${
              employee.status === 'pending' ? styles.pending : ''
            }`}
          >
            <img
              className={styles.avatar}
              src={employee.avatar}
              alt=''
              aria-hidden='true'
              draggable={false}
            />
            <div className={styles.employeeDetails}>
              <strong className={styles.employeeName}>
                {t(`employees.${employee.id}.name`)}
              </strong>
              <span className={styles.hours}>
                {t(`employees.${employee.id}.hours`)}
              </span>
            </div>
            <span className={styles.status}>
              <Checkmark aria-hidden='true' />
              {t(`status.${employee.status}`)}
            </span>
          </div>
        ))}
      </div>

      <div className={styles.actions}>
        <div className={styles.secondaryAction}>{t('sign_off')}</div>
        <div className={styles.primaryAction}>{t('remind_outstanding')}</div>
      </div>
    </section>
  )
}
